export default __webpack_public_path__ + "static/media/about_picture.7c66b254.png";